import { makeStyles } from "@mui/styles";
import { Button, Grid } from "@mui/material";
import { BasicDoc, Hit } from "react-instantsearch-core";
import { connectInfiniteHits } from "react-instantsearch-dom";

import HitCard from "../hit/hitcard-horizontal";

const useStyles = makeStyles((theme) => ({
  card: {
    display: "inline-block",
    flex: 1,
    width: "100%",
    maxWidth: 360,
  },
  gridItem: {
    minHeight: 356,
    height: "auto",
  },
  button: {
    minWidth: "200px",
    fontSize: "1rem",
  },
}));

const InfiniteHitsRows: React.FunctionComponent<any> = (props) => {
  const { hits, refineNext }: { hits: Hit<BasicDoc>[]; refineNext: Function } = props;
  const classes = useStyles();

  return (
    <Grid container spacing={2} mt="1rem">
      {hits.map((hit: Hit<BasicDoc>, i: number): JSX.Element => {
        return (
          <Grid className={'new-icon-padding new-icon-rows'} key={`hit-${hit.id}`} item xs={12}>
            <HitCard className={classes.card} hit={hit} />
          </Grid>
        );
      })}
      <Grid item xs={12} textAlign="center">
        <Button onClick={() => refineNext()} variant="outlined" color="secondary" className={`${classes.button} btn btn-secondary`}>
          Visa fler
        </Button>
      </Grid>

      {/* <Grid item xs={12} textAlign="center">
        <a href="/sok">Gå till Hitta i utbudet</a>
      </Grid> */}
    </Grid>
  );
};

export default connectInfiniteHits(InfiniteHitsRows);
